module.exports = __webpack_public_path__ + "static/media/Inter-Regular.1a7f90ff.woff";